import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../profile.service';

@Component({
  selector: 'mmb-web-app-add-life-goal-modal',
  templateUrl: './add-life-goal-modal.component.html',
  styleUrls: ['./add-life-goal-modal.component.scss']
})
export class AddLifeGoalModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() lifeGoal: string;
  @Input() isEditMode: boolean;

  constructor(public modal: NgbActiveModal,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    // Ensure user profile is loaded (needed for credential uuid in updateUserCredentials)
    this.profileService.getUserProfile().subscribe();
  }

  addLifeGoal() {
    if (this.lifeGoal == null || (this.lifeGoal ?? '').trim() === '') {
      return;
    }
    // Only send the changed field - sending the full credentials object causes
    // ValidationError when nested objects (e.g. compensation_currency_target) are
    // sent as dicts instead of pk values.
    this.profileService.updateUserCredentials({ life_goal: this.lifeGoal }).subscribe((response) => {
      this.modal.close();
    });
  }

  onClose() {
    this.closed.emit();
  }
}
